import { captureException, captureMessage } from "../config/sentry";

/**
 * Enhanced error handler utility for consistent error logging across the application
 */
export class ErrorHandler {
  /**
   * Handle API errors with comprehensive context
   * @param {Error} error - The error object
   * @param {Object} context - Additional context information
   * @param {string} context.component - Component name where error occurred
   * @param {string} context.apiEndpoint - API endpoint that failed
   * @param {Object} context.requestData - Request data that was sent
   * @param {string} context.operation - Description of the operation
   * @param {Object} context.surveyData - Survey-specific data
   */
  static handleApiError(error, context = {}) {
    const {
      component = "unknown",
      apiEndpoint = "unknown",
      requestData = {},
      operation = "API call",
      surveyData = {},
    } = context;

    // Log to console for development
    console.error(`API Error in ${component}:`, error);
    console.error("Context:", context);

    // Capture in Sentry with comprehensive context
    captureException(error, {
      api: {
        endpoint: apiEndpoint,
        method: requestData.method || "unknown",
        data: requestData.data || requestData,
        operation: operation,
      },
      component: {
        name: component,
        timestamp: new Date().toISOString(),
      },
      survey: surveyData,
      browser: {
        userAgent: navigator.userAgent,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      },
    });

    // Also capture as a message for additional visibility
    captureMessage(
      `API Error: ${operation} failed in ${component}`,
      "error",
      {
        error: {
          message: error.message,
          status: error.response?.status,
          statusText: error.response?.statusText,
        },
        context: context,
      }
    );
  }

}


export default ErrorHandler;
